module.exports = __webpack_public_path__ + "img/th_TH.c20ffd6.jpg";